<template>
  <div>

    <van-pull-refresh v-model="loading" @refresh="refresh()">
      <div class="detail-box ">

          <div class="detail-info">
            <!--详情-->
            <div class="det">
              <ul>
                <li>
                  <span>订单编号：</span>
                  <b>{{record.orderNo}}</b>
                </li>

                <li>
                  <span>场馆名称：</span>
                  <b>{{record.groundName}}</b>
                </li>

                <li>
                  <span>场地类型：</span>
                  <b><em>{{ record.sportType }}</em></b>
                </li>

                <li>
                  <span>预约手机：</span>
                  <b>{{ record.mobileNum }}</b>
                </li>

                <li>
                  <span>日期：</span>
                  <b>{{ record.addTime }}</b>
                </li>

                <li>
                  <span>金额：</span>
                  <b><i>￥{{record.totalAmount - record.serviceMoney}}</i></b>
                </li>

                <li>
                  <span>是否包场：</span>
                  <b>{{ record.isEnclosure === '1' ? '是':'否' }}</b>
                </li>
                <li>
                  <span>场次：</span>
                  <div class="ci">
                    <b v-for="(item,index) in record.orderDetailVos" :key="index">{{ record.groundName}} {{item.timeSlot}}</b>
                  </div>
                </li>
                <li>
                  <span style="margin-top:4px">评价得分：</span>
                  <b><van-rate v-model="parameters.evaluationStarNum" allow-half void-icon="star"  /></b>
                </li>
                <li>
                  <span style="margin-top:4px">意见：</span>
                  <div style="display: flex; flex: 1"> <textarea rows="3" v-model="parameters.evaluationContent" placeholder="请输入"></textarea></div>
                </li>
              </ul>
            </div>

          </div>


    <div class="b-but">
      <button @click="evaluation">提交</button>
    </div>

      </div>
    </van-pull-refresh>
  </div>
</template>

<script>
import {FILE_DISPLAY_PREFIX} from '@/api/upload'
import {getDictByType} from '@/api/common'
import {getDictName} from '@/utils/common'
import {get,evaluation} from '@/api/order/order'
import CampusCardPayment from '@/views/order/components/CampusCardPayment'
import {Dialog} from "vant";

export default {
  name: 'orderDetail',
  components: {
    // eslint-disable-next-line vue/no-unused-components
    CampusCardPayment
  },
  data() {
    return {
      fileDisplayPrefix: FILE_DISPLAY_PREFIX,
      id: '',
      record: {

      },
      parameters:{evaluationStarNum:5, evaluationContent:''},
      sportTypeList: [],
      getDictName,
      loading: false
    }
  },
  computed: {},
  created() {
    this.id = this.$route.query.id
    this.refresh()
  },
  mounted() {
  },
  methods: {

    evaluation(){
        this.parameters.id = this.id
        Dialog.confirm({
          message: '是否提交',
        })
            .then(() => {
              evaluation( this.parameters).then(res => {
                if (res.code === 10000){
                  this.$toast("提交成功")
                  this.refresh()
                }else {
                  this.$toast("提交失败")
                }
              })
            })
            .catch(() => {
            });
    },

    refresh() {
      this.getDict()
      this.getDetail()
    },
    getDetail() {
      get(this.id).then(res => {
        if (res.code === 10000) {
          this.record = res.result
        }
      }).finally(() => {
        setTimeout(() => {
          this.loading = false
        }, 100)
      })
    },
    back() {
      this.$router.go(-1)
    },
    getDict() {
      getDictByType('sport_type').then(res => {
        if (res.result) {
          this.sportTypeList = res.result.map(item => {
            return {label: item.dictKey, value: item.dictValue}
          })
        }
      })
    }
  }
}
</script>

<style scoped>
/deep/.van-rate__icon{
  font-size:14px;
}
/deep/.van-rate__icon--full{
  color: #6988FF;
}
.pay{
  display: flex;
  height:48px;
  background: #9DAFD3;
  border-radius: 3px;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 15px;
}
.pay button{
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  width:168px;
  height:48px;
  background: #2C68E4;
  border-radius: 3px;
  font-size:18px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #FFFFFF;
}
.pay span{
  font-size:14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #FFFFFF;
  padding: 0 10px;
}
.pay span b{
  font-size:16px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #FFFFFF;
}

.heji{
  display: flex;
  flex-direction: column;
  padding: 10px 0;
}
.heji span{
  display: flex;
  font-size:12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  margin:5px 0;
}
.heji span em{
  color: #ff0000;
}
.detail-box{
  padding: 10px;
  min-height:100vh;
  position: relative;
  overflow: hidden;
  background: #ffffff;
}

.detail-info{
  padding: 0 15px;
  background:#EEF3F8;
  position: relative;
}
.detail-info h2{
  display: flex;
  font-size:16px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #000000;
  padding:25px 0 10px 0;
}
.det ul li{
  display: flex;
  padding:14px 0;
  border-bottom: 1px solid #dedede;
  align-items: flex-start;
}
.det ul li span{
  font-size:14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #777777;
  display: flex;
  justify-content: flex-end;
  width: 70px;
}
.det ul li textarea{
  height: 75px;
  background: #FFFFFF;
  border: 1px solid #DEDEDE;
  border-radius: 3px;
  padding: 5px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  overflow: visible;
  width: 100%;
}
.det ul li b{
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}
.det ul li em{
  display: flex;
  align-items: center;
  justify-content: center;
  height:20px;
  background: #DEE3F9;
  border-radius: 18px;
  font-size:11px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  padding: 0 5px;
  margin-left: 3px;
}
.det ul li i{
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #FF6600;
}
.ci{
  display: flex;
  flex-direction: column;
}
.ci b{
  display: flex;
  align-items: center;
  font-size:14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  margin-bottom:10px;
}
.det ul li b.strong{
  font-size:16px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333333;
}
.mxi{
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}
.mxi h3{
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-right:20px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}
.mxi h4{
  display: flex;
  align-items: center;
  justify-content: flex-end;
  font-size:14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}
.mxi h4 strong{
  color: #FF6600;
}
</style>
